// packages/kern/src/zeit.ts — Zeitrechnung und Kleinkram (SPEC §3.3).
// Wortgleich aus dem Prototyp portiert, nur als Modul.
//
// KEIN DOM: außer `text-canvas.ts` darf keine Datei in `packages/kern/src`
// `document`, `window`, `navigator`, `fetch`, `localStorage` oder einen
// React-Import enthalten.

import type { Mi, Plan } from "./types";

export const uid = (): string => Math.random().toString(36).slice(2, 9);

/** Tiefe Kopie ueber JSON — der Plan enthaelt nur JSON-Werte. */
export const klon = <T>(o: T): T => JSON.parse(JSON.stringify(o)) as T;

/** "2026-10" -> 24321 (Jahr*12 + Monat-1; 2026*12 = 24312, plus 9). */
export const parseYM = (s: string): number => {
  const p = String(s ?? "").split("-");
  return Number(p[0]) * 12 + (Number(p[1]) - 1);
};

/** 24321 -> "2026-10". */
export const toYM = (v: number): string => {
  const y = Math.floor(v / 12);
  const m = (v % 12) + 1;
  return y + "-" + String(m).padStart(2, "0");
};

export const daysInMonth = (y: number, m: number): number =>
  new Date(Date.UTC(y, m + 1, 0)).getUTCDate();

/** Zeitstempel (ms, UTC) -> Monatsindex + (Tag-1)/Tage-im-Monat. */
export const dateToMi = (ts: number): Mi => {
  const d = new Date(ts);
  const y = d.getUTCFullYear(), m = d.getUTCMonth(), day = d.getUTCDate();
  return y * 12 + m + (day - 1) / daysInMonth(y, m);
};

export const minMi = (plan: Plan): Mi => parseYM(plan.start);
export const maxMi = (plan: Plan): Mi => parseYM(plan.end) + 1;
export const snapMi = (plan: Plan, v: Mi): Mi => { const g = plan.grid || 1; return Math.round(v / g) * g; };
export const clampMi = (plan: Plan, v: Mi): Mi => Math.max(minMi(plan), Math.min(maxMi(plan), v));
